import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

function* getVersion() {
  try {
    const { data } = yield call(request, API.VERSION, 'GET');

    yield put(actions.getVersionSuccess(data));
  } catch (e) {
    yield put(actions.getVersionError(e));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getVersionWatcher() {
  yield takeEvery(constants.GET_VERSION, getVersion);
}
